export const LogoMark = ({ size = 44 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    role="img"
    aria-label="Ansar Public School logo"
    className="shrink-0"
  >
    <rect width="64" height="64" rx="14" fill="#164E63" />
    <path
      d="M32 14v6M22 17l3 4M42 17l-3 4"
      stroke="#F59E0B"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <circle cx="32" cy="26" r="7" fill="#F59E0B" />
    <path
      d="M10 38c7-4.5 15-4.5 22 0 7-4.5 15-4.5 22 0v13c-7-4.5-15-4.5-22 0-7-4.5-15-4.5-22 0z"
      fill="#FFFFFF"
    />
    <path d="M32 38v13" stroke="#164E63" strokeWidth="2.5" />
    <path
      d="M14 42.5c5-2.6 10.5-2.8 15-0.8M35 41.7c4.5-2 10-1.8 15 .8"
      stroke="#2F855A"
      strokeWidth="1.8"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ compact = false, light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark size={compact ? 38 : 44} />
    {!compact && (
      <span className="flex flex-col leading-tight">
        <span
          className={`font-display text-lg font-extrabold tracking-tight ${
            light ? "text-white" : "text-brand-ink"
          }`}
        >
          Ansar Public School
        </span>
        <span
          className={`text-[11px] font-semibold uppercase tracking-[0.14em] ${
            light ? "text-brand-light" : "text-brand"
          }`}
        >
          Mundeke Goraya · Daska
        </span>
      </span>
    )}
  </span>
);
